import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Select } from 'antd'
import moment from 'moment'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const { Option } = Select

const BARANGAY_SHIFT_SCHEDULES = gql`
    query barangayShiftSchedules($barangay_uid: String, $searchFilter: SearchParams) {
		barangayShiftSchedules(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const ShiftSchedule = (props) => {
	const { 
		client, barangay_uid,
		onSelectedItem, onChange, ...rest 
	} = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={BARANGAY_SHIFT_SCHEDULES}
			variables={{
				barangay_uid,
				searchFilter: { page: 1, pageSize: 50, searchText }
			}}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const shiftSchedules = _.has(data, 'barangayShiftSchedules') ? data.barangayShiftSchedules.data : []
				//console.log('purok', purok)
				return (
					<Select { ...rest }
						loading={loading}
						allowClear
						showSearch
						placeholder='Select Shift Schedule'
						onSearch={(value) => setSearchText(value)}
						notFoundContent={null}
						showArrow={false}
						filterOption={false}
						onChange={(value) => {
							if (onSelectedItem) {
								const mShiftSchedule = _.find(shiftSchedules, (i) => _.isEqual(i.uid, value))
								onSelectedItem(mShiftSchedule)
							}
							onChange(value)
						}}
					>
						{
							shiftSchedules.map((item, key) => (
								<Option key={key} value={item.uid}>
									{item.shift_name} ({moment(moment(item.shift_start, 'HH:mm')).format('hh:mm a')} to {moment(moment(item.shift_end, 'HH:mm')).format('hh:mm a')})
								</Option>
							))
						}
					</Select>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(ShiftSchedule)